import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
var StatusBadge = function StatusBadge(_ref) {
  var className = _ref.className,
    label = _ref.label,
    dataId = _ref['data-testid'];
  return /*#__PURE__*/React.createElement("div", {
    className: cx(className, 'inline items-center px-2 py-1 rounded-full text-xs whitespace-no-wrap'),
    "data-testid": dataId
  }, label);
};
StatusBadge.propTypes = {
  className: PropTypes.string,
  'data-testid': PropTypes.string,
  label: PropTypes.string.isRequired
};
StatusBadge.defaultProps = {
  className: '',
  'data-testid': undefined
};
export default StatusBadge;
//# sourceMappingURL=StatusBadge.js.map